
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { TaskActionType } from 'enums/TaskActionType';
import { Model, ModelProperty } from 'models/Model';


export class CloseTaskActionRequestModel extends Model<CloseTaskActionRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'taskActionId', type: 'guid', languageString: 'closeTaskActionRequest.property.taskActionId' },
		{ name: 'logComments', type: 'string', languageString: 'closeTaskActionRequest.property.logComments' },
		{ name: 'logEntryStatus', type: 'string', languageString: 'closeTaskActionRequest.property.logEntryStatus' },
		{ name: 'followUpDate', type: 'Date', languageString: 'closeTaskActionRequest.property.followUpDate' },
		{ name: 'followUpTaskType', type: 'TaskActionType', languageString: 'closeTaskActionRequest.property.followUpTaskType' },
		{ name: 'dateOnly', type: 'boolean', languageString: 'closeTaskActionRequest.property.dateOnly' },
		{ name: 'mailData', type: 'string', languageString: 'closeTaskActionRequest.property.mailData' },
		{ name: 'canceled', type: 'boolean', languageString: 'closeTaskActionRequest.property.canceled' }
	];
	[key: string]: any;
	
	public taskActionId?: string;
	public logComments?: string;
	public logEntryStatus?: string;
	public followUpDate?: Date;
	public followUpTaskType?: TaskActionType;
	public dateOnly: boolean;
	public mailData?: string;
	public canceled: boolean;
    
	constructor(){
		super();
		this.taskActionId = undefined;
		this.logComments = undefined;
		this.logEntryStatus = undefined;
		this.followUpDate = undefined;
		this.followUpTaskType = undefined;
		this.dateOnly = false;
		this.mailData = undefined;
		this.canceled = false;
		
	}
	getProperties(){
		return CloseTaskActionRequestModel.classProperties;
	}
}

